export default __webpack_public_path__ + "static/media/icon_accommodation.59ea150f.svg";